import type { GCGeneralLink } from "@/types"

export function getGCGeneralLinkHref(link: GCGeneralLink) {
    const href =
        link.external ||
        link.internal ||
        (link.newCategoryUri && `/categories/${link.newCategoryUri}`) ||
        (link.categoryUri && `/categories/${link.categoryUri}`) ||
        (link.productDisplayUri && `/product/${link.productDisplayUri}`) ||
        (link.gcProductVariantUri && `/product/${link.gcProductVariantUri}`) ||
        (link.gcProductVariantId && `/product/${link.gcProductVariantId}`) ||
        undefined

    if (typeof href !== "string") return undefined

    if (link.external) return href

    return href.startsWith("/") ? href : `/${href}`
}
